@if (canRestore()) {
  <span>
    <button mat-flat-button color="primary" (click)="restore()">Restore</button>
  </span>
}
@if (canReject()) {
  <span>
    <button mat-flat-button color="primary" (click)="reject()">Reject</button>
  </span>
}
